import * as React from 'react';
import { Button, ModalWindow, useDeviceType } from '@cian/ui-kit';

import * as style from './RegionsModal.css';
import { IRegion } from '../../types/region/region';
import { RegionItem } from '../RegionItem';

export interface IRegionsModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (region: IRegion) => void;
  primalRegions: IRegion[];
  currentRegion: IRegion;
  regions: IRegion[][];
}

export const RegionsModal: React.FC<IRegionsModalProps> = props => {
  const { open, primalRegions, regions, onClose, onSubmit } = props;
  const [selectedRegion, setSelectedRegion] = React.useState(props.currentRegion);
  const deviceType = useDeviceType();
  const buttonSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);
  const fullWidth = React.useMemo(() => deviceType === 'phone', [deviceType]);

  React.useEffect(() => {
    setSelectedRegion(props.currentRegion);
  }, [props.currentRegion]);

  const handleClose = React.useCallback(() => {
    setSelectedRegion(props.currentRegion);
    onClose();
  }, [props.currentRegion, onClose]);

  const handleSubmit = React.useCallback(() => {
    onSubmit(selectedRegion);
    onClose();
  }, [onSubmit, onClose, selectedRegion]);

  const handleChange = React.useCallback((newRegion: IRegion) => {
    setSelectedRegion(newRegion);
  }, []);

  return (
    <ModalWindow
      size={'XS'}
      fixed={true}
      width={'100%'}
      maxWidth={'1280px'}
      open={open}
      onClose={handleClose}
      content={
        <div className={style['content']} data-testid="RegionsModal">
          <div className={style['primal']}>
            {primalRegions.map(region => (
              <RegionItem
                key={region.id}
                region={region}
                checked={region.id === selectedRegion.id}
                onChange={handleChange}
              />
            ))}
          </div>
          <div className={style['groups']}>
            {regions.map(column => {
              const [firstLetter] = column[0].name;

              return (
                <div className={style['group']} key={`${selectedRegion.id}}${firstLetter}`}>
                  <span className={style['group-title']}>{firstLetter}</span>
                  <div className={style['group-content']}>
                    {column.map(region => (
                      <RegionItem
                        key={region.id}
                        region={region}
                        checked={region.id === selectedRegion.id}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      }
      footer={
        <div className={style['footer']}>
          <Button
            onClick={handleSubmit}
            data-testid="RegionsModalSubmit"
            size={buttonSize}
            fullWidth={fullWidth}
            theme="fill_primary"
          >
            Найти застройщиков
          </Button>
        </div>
      }
    />
  );
};
